import { Button, Col, Form, Input, Row, Space, theme, Table, message, Popconfirm, Select, DatePicker } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import ModalExportOrder from './component/ModalExportOrder';
import { employees_list, export_orders_cancel, export_orders_create, export_orders_get_detail, export_orders_list, import_orders_cancel, import_orders_create, import_orders_get_detail, import_orders_list, opening_order_cancel, opening_order_create, opening_order_detail, opening_order_list, product_list, warehouse_list } from '../../services/apis';
import { FORMAT_DATE, HeaderTableCus, TYPE_MODAL } from '../../constants/constants';
import { useSelector } from 'react-redux';
import { filterOption } from '../../utils/funcHelper';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { consoleLogUtil } from '../../utils/consoleLogUtil';
import dayjs from 'dayjs';

const ListExportOrderPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const [typeModal, setTypeModal] = useState();
    const [titleModal, setTitleModal] = useState('');
    const [dataWarehouses, setDataWarehouses] = useState([]);
    const [dataProducts, setDataProducts] = useState([]);
    const userReducer = useSelector((state) => state.userReducer?.data);
    const [dataEmployees, setDataEmployees] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const columns = [
        {
            title: 'STT',
            key: 'STT',
            width: 80,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Mã phiếu',
            dataIndex: 'order_code',
            key: 'order_code',
            width: 80,
            align: 'center',
            render: (text, record, index) => <a onClick={() => handleShowDetailOpeningBalance(record)} style={{ paddingLeft: 12 }}>{text}</a>,
        },
        {
            title: 'Tên kho',
            dataIndex: 'warehouse_name',
            key: 'warehouse_name',
            align: 'center',
            render: (text, record, index) => <span>{text}</span>,
        },
        {
            title: 'Tên khách hàng',
            dataIndex: 'customer_name',
            key: 'customer_name',
            align: 'center',
            render: (text, record, index) => <span>{text}</span>,
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'customer_phone',
            key: 'customer_phone',
            align: 'center',
            render: (text, record, index) => <span>{text}</span>,
        },
        {
            title: 'Ghi chú',
            dataIndex: 'notes',
            key: 'notes',
            align: 'center',
            render: (text, record, index) => <div style={{textAlign: 'left'}}>{text}</div>
        },
        {
            title: 'Ngày xuất',
            dataIndex: 'export_date',
            key: 'export_date',
            align: 'center',
            render: (text, record, index) => <span>{text ? dayjs(text).format(FORMAT_DATE.DDMMYYYY) : ''}</span>,
        },
        {
            title: 'Thời gian tạo',
            dataIndex: 'created_at',
            key: 'created_at',
            align: 'center',
            render: (text, record, index) => <span>{text ? dayjs(text).format(FORMAT_DATE.DDMMYYYYHHMMSS) : ''}</span>,
        },
        {
            title: 'Người tạo',
            dataIndex: 'created_by_name',
            key: 'created_by_name',
            align: 'center',
            render: (text, record, index) => <span>{text}</span>,
        },
        {
            title: 'Hành động',
            dataIndex: 'action',
            key: 'action',
            width: 120,
            align: 'center',
            render: (text, record) => (
                <Space size="middle">
                    <a onClick={() => handleShowDetailOpeningBalance(record)} >Xem</a>
                    <Popconfirm
                        title="Bạn có chắc chắn muốn huỷ phiếu này?"
                        onConfirm={() => handleCancelExportOrder(record)}
                        okText="Đồng ý"
                        cancelText="Đóng"
                        placement="topRight"
                    >
                        <a style={{ color: 'red' }}>Huỷ phiếu</a>
                    </Popconfirm>
                </Space>
            ),
        },
    ];
    const { RangePicker } = DatePicker;
    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const getDataEmployees = async () => {
        try {
            const params = {
                keyword: '',
                branch_id: null,
                limit: 100,
                currentPage: 1,
            }
            const res = await employees_list(params);
            if (res && res.status === 1) {
                setDataEmployees([...res?.data?.data?.map((item) => ({
                    ...item,
                    label: item.full_name,
                    value: item.id
                }))
                ]);
            } else {
                setData([]);
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const handleCancelExportOrder = async (record) => {
        try {
            const params = {
                export_order_id: record?.id,
                updated_by: userReducer?.user_info?.id
            }
            setLoading(true);
            const res = await export_orders_cancel(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Huỷ thành công');
                getDataExportOrders(true);
            }
            else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            console.log('error', error);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
    }

    const handleShowDetailOpeningBalance = (record) => {
        getExportOrderDetail(record?.id);
    }
    const handleCreateExportOrder = () => {
        setTypeModal(TYPE_MODAL.ADD);
        setShowModal(true);
        setTitleModal('Thêm mới phiếu xuất hàng');
    }

    const getExportOrderDetail = async (id) => {
        try {
            const params = {
                id: id,
            }
            setLoading(true);
            const res = await export_orders_get_detail(params);
            setLoading(false);
            if (res && res.status === 1) {
                setItemSelected(res?.data);
                setTypeModal(TYPE_MODAL.EDIT);
                setShowModal(true);
                setTitleModal('Chi tiết phiếu xuất hàng #' + res?.data?.order?.order_code);
            }
            else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setItemSelected(null);
            }
        } catch (error) {
            console.log('error', error);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
    }

    const getDataExportOrders = async (showLoading, size, current) => {
        try {
            const params = {
                keyword: form.getFieldValue('name') ?? '',
                status: 'completed',
                warehouse_id: form.getFieldValue('warehouse_id') ?? null,
                created_by: null,
                date_from: form.getFieldValue('date') ? form.getFieldValue('date')[0].format(FORMAT_DATE.YYYYMMDD) : null,
                date_to: form.getFieldValue('date') ? form.getFieldValue('date')[1].format(FORMAT_DATE.YYYYMMDD) : null,
                currentPage: current ?? currentPage,
                limit: size ?? pageSize,
            }
            if (showLoading) setLoading(true);
            const res = await export_orders_list(params);
            if (showLoading) setLoading(false);
            if (res && res.status === 1) {
                setData([...res?.data?.data]);
                setTotalRecords(res?.data?.pagination?.total_records);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setData([]);
                setTotalRecords(0);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }


    }

    const getDataWarehouses = async () => {
        try {
            const params = {
                keyword: '',
                status: 'active',
                currentPage: 1,
                limit: 100,
            }
            const res = await warehouse_list(params);
            if (res && res.status === 1) {
                setDataWarehouses([...res?.data?.items?.map((item) => ({
                    ...item,
                    label: item.name,
                    value: item.id
                }))]);
            } else {
                setDataWarehouses([]);
            }
        } catch (error) {
            console.log('error', error);
        }


    }

    const onFinish = async (dataForm) => {
        getDataExportOrders(true);
    };
    const callApiCreateExportOrder = async (data) => {
        consoleLogUtil('callApiCreateExportOrder data', data);
        try {
            const params = {
                ...data,
                created_by: userReducer?.user_info?.id
            }
            setLoading(true);
            const res = await export_orders_create(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Thêm mới thành công');
                getDataExportOrders(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        }
    }

    const getDataProducts = async () => {
        try {
            const params = {
                keyword: '',
                status: 'active',
                currentPage: 1,
                limit: 200,
            }
            const res = await product_list(params);
            if (res && res.status === 1) {
                setDataProducts([...res?.data?.data?.map((item) => ({
                    ...item,
                    label: item.name,
                    value: item.id
                }))
                ]);
            } else {
                setDataProducts([]);
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const callApiUpdateExportOrder = async (data) => {

    }
    const handleOnSave = async (data) => {
        setShowModal(false);
        if (typeModal === TYPE_MODAL.ADD) {
            callApiCreateExportOrder(data);
        } else {
            callApiUpdateExportOrder(data);
        }
    }

    useEffect(() => {
        setLoading(true);
        Promise.all([getDataWarehouses(), getDataProducts(), getDataEmployees(), getDataExportOrders(false)]).finally(() => {
            setLoading(false);
        });
    }, [])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name={'name'}
                        >
                            <Input
                                placeholder={'Nhập tên'}
                                className='custom-input-antd'
                            />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            name={'warehouse_id'}
                        >
                            <Select
                                placeholder="Chọn kho"
                                options={dataWarehouses}
                                filterOption={filterOption}
                                showSearch
                                className='custom-input-antd'
                                style={{ width: '100%', height: 40 }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="date"
                        >
                            <RangePicker
                                format={FORMAT_DATE.DDMMYYYY}
                                allowClear={false}
                                className='custom-input-antd'
                                style={{ width: '100%' }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Space size="small">
                            <Button
                                type="primary"
                                htmlType="submit"
                                icon={<SearchOutlined />}
                                className='custom-input-antd'
                            >
                                Tìm kiếm
                            </Button>
                            <Button danger
                                onClick={handleCreateExportOrder}
                                icon={<PlusOutlined />}
                                className='custom-input-antd'
                            >
                                Thêm mới
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    total: totalRecords,
                    showTotal: (total) => `Tổng ${total} phiếu xuất hàng`,
                    showSizeChanger: true,
                    onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                        getDataExportOrders(true, size, page);
                    },
                    onShowSizeChange: (current, size) => {
                        setCurrentPage(1);
                        setPageSize(size);
                        getDataExportOrders(true, size, 1);
                    }
                }}
                rowKey={(record) => record?.id}
                bordered
                rowClassName={() => 'custom-row'}
            />
            <ModalExportOrder
                visible={showModal}
                onCancel={() => setShowModal(false)}
                data={itemSelected}
                title={titleModal}
                onSave={handleOnSave}
                type={typeModal}
                warehouses={dataWarehouses}
                products={dataProducts}
                employees={dataEmployees}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ListExportOrderPage);